import { Notification } from '@cambridgeassessment/cambridge-ui';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import useNotifications from '../../hooks/useNotifications';
import { useNotificationStyles } from './styles';

const Notifications: React.FC = () => {
  const { notifications, removeNotification } = useNotifications();
  const classes = useNotificationStyles();
  return (
    <div className={classes.notificationsContainer}>
      {notifications.map((notification, idx) => (
        <Notification
          data-testid="notification"
          key={notification.id || idx}
          onClick={notification.onClick}
          closeable
          variant={notification.variant || 'success'}
          title={notification.title}
          size="small"
          onClose={(e) => {
            e && e.stopPropagation();
            removeNotification(notification, true);
          }}
          className={classes.notification}
        >
          {notification.text}
        </Notification>
      ))}
    </div>
  );
};

export default hot(Notifications);
